"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Blanket = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _layers = require("../../constants/layers");
var _noop = require("../../constants/noop");
var _theme = require("../../theme");
var _BlanketStyled = require("./styled/BlanketStyled");
/**
 * The main purpose of the blanket component is to provide the overlay layer for components such as
 * a modal dialog or menu.
 */
const Blanket = _ref => {
  let {
    canClickThrough = false,
    className,
    isTinted = false,
    onClick = _noop.noop,
    onDoubleClick = _noop.noop,
    clientId,
    zIndex = _layers.layers.blanket
  } = _ref;
  const {
    key
  } = (0, _theme.useTheme)();
  const themeMode = key;
  const combinedClassName = (0, _classnames.default)((0, _theme.getThemeClasses)(themeMode), className); //this enables custom classNames while still including required theme classNames
  return /*#__PURE__*/_react.default.createElement(_BlanketStyled.BlanketStyled, {
    canClickThrough: canClickThrough,
    className: combinedClassName,
    "data-client-id": clientId,
    isTinted: isTinted,
    onClick: canClickThrough ? undefined : onClick,
    onDoubleClick: canClickThrough ? undefined : onDoubleClick,
    themeMode: themeMode,
    zIndex: zIndex
  });
};
exports.Blanket = Blanket;
//# sourceMappingURL=Blanket.js.map